import { Navigate } from "react-router-dom";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";

const PrivateRoute = ({ children }) => {
  const isAuthenticated = useIsAuthenticated();
  const { inProgress, instance, accounts } = useMsal();

  // Đang khởi tạo hoặc xử lý redirect → chưa kết luận
  if (
    inProgress === InteractionStatus.Startup ||
    inProgress === InteractionStatus.HandleRedirect
  ) {
    return null; // hoặc <Spinner />
  }

  // Tuỳ chọn: bảo đảm có active account
  const active = instance.getActiveAccount();
  if (!active && accounts.length > 0) {
    instance.setActiveAccount(accounts[0]);
  }

  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

export default PrivateRoute;
